// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"62c7b28f","977":"ecd626a3"}[chunkId] + ".chunk.js";
};